import { AboutFour } from "../../components/About/AboutFour";
import { BannerThree } from "../../components/Banners/BannerThree";
import { BlogAreaThree } from "../../components/BlogAreas/BlogAreaThree";
import { BrandTwo } from "../../components/Brand/BrandTwo";
import { CounterAreaTwo } from "../../components/CounterAreas/CounterAreaTwo";
import { CtaAreaTwo } from "../../components/CtaAreas/CtaAreaTwo";
import { FeatureThree } from "../../components/Features/FeatureThree";
import { OverviewAreaTwo } from "../../components/OverviewAreas/OverviewAreaTwo";
import { TestimonialAreaThree } from "../../components/TestimonialAreas/TestimonialAreaThree";
import { TeamAreaThree } from "../../components/TeamAreas/TeamAreaThree";
import { useTranslation } from "react-i18next";
import { Layout } from "../../layouts/Layout";

const HomeTwo = () => {
  const { t } = useTranslation();
  return (
    <Layout header={3} footer={2}>
      {/* banner-area */}
      <BannerThree />

      {/* brand-area */}
      <BrandTwo title={t("home.brandsTitle")} />

      {/* features-area */}
      <FeatureThree />

      {/* about-area */}
      <AboutFour />

      {/* overview-area */}
      <OverviewAreaTwo />

      {/* counter-area */}
      <CounterAreaTwo />

      {/* testimonial-area */}
      <TestimonialAreaThree />

      {/* cta-area */}
      <CtaAreaTwo />

      {/* blog-area */}
      <BlogAreaThree />

      {/* team-area */}
      <TeamAreaThree />
    </Layout>
  );
};

export default HomeTwo;
